

import "./Chatbot.css";
import React, { useState, useEffect, useRef } from "react";
import useTemplates from "../../services/Whatsapp/useTemplates";

export default function WhatsAppFlow({ userID }) {
 
  const [selectedTemplate, setSelectedTamplate] = useState([]);
const { templates, fetchTemplatesByUser, loading } = useTemplates();

const [nodes, setNodes] = useState([
  {
    id: "start",
    text: "Hii",
    content: "",
    x: 80,
    y: 120,
    children: [],
    template: [],
  },
]);

  const containerRef = useRef(null);
const nodeRefs = useRef({});
  const refs = useRef({});
  const draggingNode = useRef(null);
  const offset = useRef({ x: 0, y: 0 });

  const [textMessage, setTextMessage] = useState("");
  const [listTitle, setListTitle] = useState("");
  const [interactiveList, setInteractiveList] = useState([]);

  const handleInteractiveListChange = (index, value) => {
    const newList = [...interactiveList];
    newList[index] = value;
    setInteractiveList(newList);
  };

  const addListItem = () => {
    if (interactiveList.length < 5) {
      setInteractiveList([...interactiveList, ""]);
    }
  };

  const adjustContainerSize = () => {
    const minY = Math.min(...nodes.map((node) => node.y));
    if (minY < 50) {
      setNodes((prevNodes) =>
        prevNodes.map((node) => ({
          ...node,
          y: node.y + Math.abs(minY) + 100,
        }))
      );
    }
  };

  useEffect(() => {
    adjustContainerSize();
  }, [nodes]);

  useEffect(() => {
  fetchTemplatesByUser();
}, []);

useEffect(() => {
  const centerStartNode = () => {
    const container = containerRef.current;
    const startNode = nodeRefs.current["start"];

    if (!container || !startNode) return;

    const containerHeight = container.clientHeight;
    const nodeHeight = startNode.offsetHeight;

    const centeredY = Math.max(80, (containerHeight - nodeHeight) / 2);

    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === "start"
          ? {
              ...node,
              x: 80,
              y: centeredY,
            }
          : node
      )
    );
  };

  centerStartNode();

  window.addEventListener("resize", centerStartNode);

  return () => {
    window.removeEventListener("resize", centerStartNode);
  };
}, []);

  const buttonTypes = [
    "Catalog",
    "Template Message",
    "Text Message",
    "Interactive List",
  ];

  const calculatePosition = (parent, btnIndex, totalButtons) => {
    const verticalSpacing = 200;
    const horizontalSpacing = 500;
    const childX = parent.x + horizontalSpacing;
    const childY =
      parent.y + (btnIndex - (totalButtons - 1) / 2) * verticalSpacing;

    return { x: childX, y: childY };
  };

  const addNode = (parentId, type, btnIndex) => {
    setNodes((prevNodes) => {
      const parent = prevNodes.find((node) => node.id === parentId);
      if (!parent) return prevNodes;

      const newNodeId = `node-${prevNodes.length}`;
      const { x, y } = calculatePosition(parent, btnIndex, buttonTypes.length);

      const newNode = {
        id: newNodeId,
        text: type,
        x,
        y,
        fromButton: btnIndex,
        content: "",
        children: [],
        template: [],
      };

      parent.children.push({ id: newNodeId, fromButton: btnIndex });

      return [...prevNodes, newNode];
    });
  };

  const handleMouseDown = (e, nodeId) => {
    draggingNode.current = nodeId;
    const node = nodes.find((n) => n.id === nodeId);

    if (node) {
      offset.current = {
        x: e.clientX - node.x,
        y: e.clientY - node.y,
      };
    }
  };

  const handleMouseMove = (e) => {
    if (!draggingNode.current) return;

    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === draggingNode.current
          ? {
              ...node,
              x: e.clientX - offset.current.x,
              y: e.clientY - offset.current.y,
            }
          : node
      )
    );
  };

  const handleMouseUp = () => {
    draggingNode.current = null;
  };

  const handleTemplateSelect = (e, nodeId) => {
    const temp = JSON.parse(e);

    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId ? { ...node, template: temp } : node
      )
    );

    setSelectedTamplate(temp);
  };

  return (
  <div
    ref={containerRef}
    className="tree-container bg-gradient-to-r from-gray-200 to-gray-300"
    onMouseMove={handleMouseMove}
    onMouseUp={handleMouseUp}
  >
    <h2 className="text-xl font-semibold mb-4 px-4 pt-2">
      Interactive WhatsApp Flow Builder
    </h2>

    {/* SVG CONNECTION */}
    <svg className="svg-layer">
      <defs>
        <marker
          id="arrowhead"
          markerWidth="10"
          markerHeight="7"
          refX="10"
          refY="3.5"
          orient="auto"
        >
          <polygon points="0 0, 10 3.5, 0 7" fill="#2563eb" />
        </marker>
      </defs>

      {nodes.map((node) =>
        node.children?.map(({ id: childId, fromButton }) => {
          const child = nodes.find((n) => n.id === childId);
          if (!child) return null;

          const btn = refs.current[`${node.id}-${fromButton}`];
          if (!btn) return null;

          const rect = btn.getBoundingClientRect();
          const parentRect = btn.closest(".node-box").getBoundingClientRect();

          const x1 = node.x + (rect.x - parentRect.x) + rect.width / 2;
          const y1 = node.y + (rect.y - parentRect.y) + rect.height / 2;

          const x2 = child.x;
          const y2 = child.y;

          return (
            <path
              key={`${node.id}-${childId}`}
              d={`M ${x1} ${y1} Q ${(x1 + x2) / 2} ${y1 - 50} ${x2} ${y2}`}
              fill="none"
              stroke="#2563eb"
              strokeWidth="2"
              strokeDasharray="5,5"
              markerEnd="url(#arrowhead)"
            />
          );
        })
      )}
    </svg>

    {/* NODES */}
    {nodes.map((node) => (
      <div
        key={node.id}
        ref={(el) => {
    nodeRefs.current[node.id] = el;
  }}

        className="node-box bg-white rounded-lg shadow-md border border-gray-200 min-w-[240px] cursor-grab active:cursor-grabbing transition"
        style={{ left: node.x, top: node.y }}
        onMouseDown={(e) => handleMouseDown(e, node.id)}
      >
        {/* START HEADER */}
        {node.id === "start" && (
          <div className="bg-gray-100 text-center text-sm font-semibold py-2 rounded-t-lg mt-4 px-3">
            Starting Step
          </div>
        )}

        {/* TITLE */}
        <div className="bg-blue-600 text-white text-sm text-center py-2 px-3 w-full mt-3 font-medium">
          {node.text}
        </div>

        {/* BODY */}
        <div className="p-3 text-sm text-gray-600">
          {node.id === "start" && (
            <div className="bg-gray-100 p-2 rounded text-center">
              Select the first response to send to the customer when they say "Hi".
            </div>
          )}
        </div>

        {/* BUTTONS */}
        {node.id === "start" && (
          <div className="p-3 flex flex-col gap-2">
            {buttonTypes.map((type, index) => (
              <button
                key={index}
                ref={(el) => (refs.current[`${node.id}-${index}`] = el)}
                onClick={() => addNode(node.id, type, index)}
                className="w-full border border-blue-500 text-blue-600 hover:bg-blue-600 px-3 hover:text-white py-2 rounded-md text-sm font-medium transition"
              >
                {type}
              </button>
            ))}
          </div>
        )}

        {/* TEXT MESSAGE */}
        {node.text === "Text Message" && (
          <div className="p-3">
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your text message"
              value={textMessage}
              onChange={(e) => setTextMessage(e.target.value)}
            />
          </div>
        )}

        {/* TEMPLATE */}
       {node.text === "Template Message" && (
  <div className="p-3">
    <select
      size={6}
      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 max-h-[220px] overflow-y-auto"
      onChange={(e) => handleTemplateSelect(e.target.value, node.id)}
    >
      <option value="">Select a Template</option>

      {loading ? (
        <option>Loading...</option>
      ) : templates?.length > 0 ? (
        templates.map((item) => (
          <option key={item.id} value={JSON.stringify(item)}>
            {item.template_name || item.name}
          </option>
        ))
      ) : (
        <option>No Templates Found</option>
      )}
    </select>

    {node.template && (
      <div className="mt-2 text-xs text-gray-500">
        Selected: {node.template?.template_name || node.template?.name}
      </div>
    )}
  </div>
)}

        {/* CATALOG */}
        {node.text === "Catalog" && (
          <div className="p-3 text-sm text-gray-600">
            Catalog Section
          </div>
        )}

        {/* INTERACTIVE LIST */}
        {node.text === "Interactive List" && (
          <div className="p-3">
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm mb-2"
              placeholder="Enter Message"
              value={listTitle}
              onChange={(e) => setListTitle(e.target.value)}
            />

            {interactiveList.map((item, index) => (
              <input
                key={index}
                type="text"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm mb-2"
                placeholder={`Option ${index + 1}`}
                value={item}
                onChange={(e) =>
                  handleInteractiveListChange(index, e.target.value)
                }
              />
            ))}

            {interactiveList.length < 5 && (
              <button
                onClick={addListItem}
                className="w-full mt-2 bg-blue-600 text-white py-2 rounded-md text-sm hover:bg-blue-700 transition"
              >
                Add Button
              </button>
            )}
          </div>
        )}
      </div>
    ))}
  </div>
);
}

